import React from "react";
import {NpsInput} from '../NpsInput';
import {Check} from 'lucide-react';
import {Typography} from '@/components/ui/typography';
import {cn} from '@/lib/utils';
import {Question} from '@/types/assessment';


type AssessmentFormQuestionProps = {
    question: Question,
    selectedScore: number,
    onChange: ({value, checked}: {
        value: number,
        checked: boolean
    }) => void
}

export const AssessmentFormQuestion = ({question, selectedScore, onChange}: AssessmentFormQuestionProps) => {
    return (
        <div className="flex gap-4" key={question.id}>
            <div className="w-full">
                <Typography className="text-sm font-bold mb-4">
                    {question.title}
                </Typography>
                <div className="w-11/12 m-auto">
                    <NpsInput
                        textMin={'strongly disagree'}
                        textMax={'strongly agree'}
                        name={question.id}
                        value={selectedScore}
                        onChange={onChange}
                    />
                </div>
            </div>
        </div>
    )
}

type Step = {
    active: boolean;
    completed: boolean;
}

type FormProgressBarProps = {
    steps: Step[];
}

export const FormProgressBar = ({steps}: FormProgressBarProps) => {
    return <div className="flex justify-between items-center relative before:absolute before:bg-teal-400 before:w-full before:left-0 before:right-0 before:block before:h-[2px] before:top-1/2 before:z-0 before:content-['']">
        {steps.map((it, index) => {
            return (
                <span
                    key={index}
                    className={cn("h-6 w-6 rounded-full bg-white shadow flex items-center justify-center decoration-0 z-0 relative", {
                        ['bg-teal-300']: it.completed && !it.active,
                    })
                    }>
                    {it.active ? <div className="h-3 w-3 bg-teal-300 rounded-full"></div> : null}
                    {it.completed && !it.active ? <Check className="w-4 h-4 text-white"/> : null}
                </span>
            )
        })}
    </div>
}

